import store from "../../config/store";
import { SiafLiteApiStream } from "../../external";
import SiafLiteApiRepository from "../../external/siafLiteApi";

class ContasReceberService {
  constructor() {
    this.urlBase = "/financeiro/contas-receber";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.urlBaseCompleta = `${store.baseUrl}${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllContasCompensar(filter) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/contas-compensar`
    ).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  compensar(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/compensar-contas-receber`
    ).post(body);
  }

  cadastrarLista(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/cadastro-lista`
    ).post(body);
  }

  importar(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/importacao`).post(
      body
    );
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  buscarOrigensRenegociacao(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/origens-renegociacao`,
    ).get();
  }

  getResumoHistoricoContasCliente(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/resumo-historico`
    ).patch();
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  baixaEmLote(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(body);
  }

  getResumoTotaisAReceber() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-contas-receber-totais`
    ).get();
  }

  getResumoContasReceber() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/estatistica/resumo-contas-receber`
    ).get();
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/resumido`
    ).patch(body);
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/detalhado`
    ).path(body);
  }

  getLimiteCreditoInadimplencia(pagadorId, limiteCliente) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/limite-credito-inadimplencia/${pagadorId}`
    ).patch({ limiteCliente });
  }

  getCarnePagamentos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/carne-pagamentos`
    ).patch(body);
  }

  getRelatorioHistoricoPagamentos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/historico-pagamentos`
    ).patch(body);
  }

  cadastrarPagamentos(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/pagamentos`
    ).post(body);
  }

  desdobrarTitulo(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/desdobrar-titulos`
    ).post(body);
  }

  enviarMensagemLote(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/mensagem-personalizada`
    ).patch(body);
  }
}

export default ContasReceberService;
